import Image from 'next/image'

export default function CustomerExperienceSection() {
  return (
    <section className='mx-auto gap-5 px-4 py-10 md:px-16 md:py-20'>
      <div className='grid grid-cols-1 max-md:gap-y-2 md:grid-cols-2'>
        <div className='text-heading-6 md:text-heading-2 max-md:text-center'>
          Trải nghiệm <br /> của khách hàng
        </div>
        <div className='text-base md:flex md:items-center md:text-2xl'>
          <div>
            <span className='font-semibold'>Coolmate</span> không ngừng đầu tư
            mạnh mẽ vào việc nâng tầm trải nghiệm mua sắm trực tuyến, đồng thời
            phát triển chương trình khách hàng thân thiết CoolClub với nhiều đặc
            quyền hấp dẫn, mang đến cho bạn những ưu đãi thiết thực và gắn kết
            bền lâu cùng thương hiệu.
          </div>
        </div>
      </div>
      <div className='mt-4 grid grid-cols-2 gap-5 md:mt-20 md:grid-cols-4'>
        <div>
          <picture className='w-full'>
            <source
              srcSet='https://mcdn.coolmate.me/image/March2025/mceclip16_28.png'
              media='(max-width: 768px)'
            />
            <Image
              src='https://mcdn.coolmate.me/image/March2025/mceclip9_64.png'
              alt='Customer Experience'
              width={1000}
              height={1000}
              className='w-full'
            />
          </picture>
        </div>
        <div>
          <picture className='w-full'>
            <source
              srcSet='https://mcdn.coolmate.me/image/March2025/mceclip14_60.png'
              media='(max-width: 768px)'
            />
            <Image
              src='https://mcdn.coolmate.me/image/March2025/mceclip10_35.png'
              alt='Customer Experience'
              width={1000}
              height={1000}
              className='w-full'
            />
          </picture>
        </div>
        <div>
          <picture className='w-full'>
            <source
              srcSet='https://mcdn.coolmate.me/image/March2025/mceclip13_52.png'
              media='(max-width: 768px)'
            />
            <Image
              src='https://mcdn.coolmate.me/image/March2025/mceclip12_47.png'
              alt='Customer Experience'
              width={1000}
              height={1000}
              className='w-full'
            />
          </picture>
        </div>
        <div>
          <picture className='w-full'>
            <source
              srcSet='https://mcdn.coolmate.me/image/March2025/mceclip15_71.png'
              media='(max-width: 768px)'
            />
            <Image
              src='https://mcdn.coolmate.me/image/March2025/mceclip11_10.png'
              alt='Customer Experience'
              width={1000}
              height={1000}
              className='w-full'
            />
          </picture>
        </div>
      </div>
    </section>
  )
}
